module.exports = __webpack_public_path__ + "static/media/cellfinate_antes_despues_antes.43ca9665.jpg";